import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { MasterDataService } from '../../../secure/master-data/_services/master-data.service';
import * as BusLineActions from '../../actions/master-data/busline.actions';

@Injectable()
export class BusLineEffects {
  constructor(
    private actions$: Actions,
    private masterDataService: MasterDataService
  ) { }

  loadBusLine$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BusLineActions.loadBusLines),
      mergeMap(() => {
        return this.masterDataService.getAllBusLines().pipe(
          map((busLines) => {
            return BusLineActions.loadBusLinesSuccess({ busLines });
          }),
          catchError((error) => {
            let errorMessage = 'error loading bus lines';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            }else{
              errorMessage = error?.message || errorMessage;
            }
            return of(BusLineActions.loadBusLineFailure({ error: errorMessage }));
          })
        );
      })
    )
  );

  addBusLine$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BusLineActions.addBusLine),
      mergeMap(({ busLine }) =>
        this.masterDataService.addNewBusLine(busLine).pipe(
          mergeMap(saved => [
            BusLineActions.addBusLineSuccess({
              busLine: saved,
              message: 'Bus line created successfully'
            }),
            BusLineActions.loadBusLines()
          ]),
          catchError((error) => {
            let errorMessage = 'An error occurred while adding the bus line.';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            }else{
              errorMessage = error?.message || errorMessage;
            }
            return of(BusLineActions.loadBusLineFailure({ error: errorMessage }));
          })
        )
      )
    )
  );

  updateBusLine$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BusLineActions.updateBusLine),
      mergeMap(({ busLine }) =>
        this.masterDataService.updateBusLine(busLine).pipe(
          mergeMap((saved) => [
            BusLineActions.updateBusLineSuccess({
              busLine: saved,
              message: 'Bus line updated successfully'
            }),
            BusLineActions.loadBusLines()
          ]),
          catchError((error) => {
            let errorMessage = 'An error occurred while updating the bus line.';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            }else{
              errorMessage = error?.message || errorMessage;
            }
            return of(BusLineActions.loadBusLineFailure({ error: errorMessage }));
          })
        )
      )
    )
  );  

  deleteBusLine$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BusLineActions.deleteBusLine),
      mergeMap(({ id }) =>
        this.masterDataService.deleteBusLine(Number(id)).pipe(
          mergeMap((saved) => [
            BusLineActions.deleteBusLineSuccess({
              message: 'Bus line deleted successfully'
            }),
            BusLineActions.loadBusLines()
          ]),
          catchError((error) => {
            let errorMessage = 'An error occurred while deleting the bus line.';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            }else{
              errorMessage = error?.message || errorMessage;
            }
            return of(BusLineActions.loadBusLineFailure({ error: errorMessage }));
          })
        )
      )
    )
  );
  
}